/**
 * Status bucketing for the "Repair Requests" widget.
 *
 * eservbusiness.repair_request.status is free-text per business. The Penpot
 * mockup locks the visual set to 5 canonical statuses, so we normalize common
 * spellings (case, spaces, hyphens, underscores, synonyms) into them:
 *   in progress / working / active        → In Progress
 *   awaiting parts / parts on order       → Awaiting Parts
 *   completed / complete / done / closed  → Completed
 *   cancelled / canceled / rejected       → Cancelled
 *   everything else (new, pending, …)     → Open
 *
 * Unknown values fall through to Open so a count is never silently dropped.
 */

export type RepairStatusKey =
  | "open"
  | "in_progress"
  | "awaiting_parts"
  | "completed"
  | "cancelled";

export function bucketRepairStatus(raw: string): RepairStatusKey {
  const n = raw.toLowerCase().trim().replace(/[\s-]+/g, "_");
  if (n === "in_progress" || n === "working" || n === "active") return "in_progress";
  if (n === "awaiting_parts" || n === "waiting_parts" || n === "parts_on_order")
    return "awaiting_parts";
  if (n === "completed" || n === "complete" || n === "done" || n === "closed")
    return "completed";
  if (n === "cancelled" || n === "canceled" || n === "rejected") return "cancelled";
  return "open";
}
